import styled from "@emotion/styled";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { Button } from "@mui/material";

import MenuItemPresenter from "presenters/MenuItemPresenter";

const SubMenuContainer = styled("div")(() => ({
  display: "flex",
  flexWrap: "nowrap",
  gap: 10,
}));

const ActiveButton = styled(Button)(({ theme }) => ({
  "&:hover": {
    "@media (hover: hover)": {
      background: theme.palette.primary.main,
      cursor: "default",
    },
  },
}));

const CategorySubMenu = ({ menuItems }) => {
  return (
    <SubMenuContainer>
      {menuItems.map((item, index) =>
        index === 0 ? (
          <ActiveButton key={index} variant="contained" color="primary">
            {item.linkText}
          </ActiveButton>
        ) : (
          <Button key={index} variant="outlined" color="primary" component={NavLink} to={item.linkTo}>
            {item.linkText}
          </Button>
        ),
      )}
    </SubMenuContainer>
  );
};

CategorySubMenu.propTypes = {
  menuItems: PropTypes.arrayOf(MenuItemPresenter.shape()),
};

export default CategorySubMenu;
